/**
 * Get the first initial of a user's name, defaulting to 'UN' if no valid name is provided
 * @param {string} name - The user's name
 * @returns {string} - The first initial in uppercase, or 'UN' if no valid name
 */
export function getUserFirstInitial(name) {
  if (!name || !name.trim()) return 'UN'
  return name[0].toUpperCase()
}
